class SearchOffersReq {
  constructor() {
    this.id = null;
    this.fidiumCustomerId = null;
    this.leadId = null;
    this.salesRepId = null;
    this.offerType = null;
    this.offerStatus = null;
    this.freeInstall = null;
    this.freeOffer = null;
    this.offerGuid = null;
    this.fiberType = null;
    this.firstName = null;
    this.lastName = null;
    this.email = null;
    this.phone = null;
    this.fiberCompanyId = null;
    this.templateId = null;
    this.promo = null;
    this.isFiberLead = null;
    this.pagingParams = {
      pageNumber: 1,
      pageSize: 200,
    };
    this.message = null;
  }
}

export default SearchOffersReq;
